import {
  FAIL_EXPLORE_TIMELINE,
  RECEIVE_EXPLORE_TIMELINE,
  REQUEST_EXPLORE_TIMELINE,
  // TODO [pg] Add dismiss support for the explore timeline.
  FAIL_DISMISS_EXPLORE_FEED_ITEM,
  REQUEST_DISMISS_EXPLORE_FEED_ITEM,
  SUCCESS_DISMISS_EXPLORE_FEED_ITEM,
  // SHOW_CONFIRM_DISMISS_FEED_ITEM,
  // HIDE_CONFIRM_DISMISS_FEED_ITEM,
  INITIAL_FETCH_COMPLETE,
} from 'shared/exploreActions';

function populateExploreTimeline(state, action, overwrite = {}) {
  const exploreTabKey = action && action.payload
     && action.payload.exploreTab && action.payload.exploreTab.timelineKey;
  if (exploreTabKey && state[exploreTabKey]) return Object.assign({}, state[exploreTabKey], overwrite);
  return overwrite;
}

export default function exploreTimeline(state = {}, action) {
  const exploreTabKey = action && action.payload
    && action.payload.exploreTab && action.payload.exploreTab.timelineKey;
  let newTimeline;

  switch (action.type) {
  case INITIAL_FETCH_COMPLETE:
    return {
      isInitialFetchComplete: true,
    };
  case FAIL_EXPLORE_TIMELINE:
    const failedUserTimeline = populateExploreTimeline(state, action, { isFetching: false, isError: true});
    return Object.assign({}, state, {
      [exploreTabKey]: failedUserTimeline,
    });

  case REQUEST_EXPLORE_TIMELINE:
    const requestedUserTimeline = populateExploreTimeline(state, action, { isFetching: true, isError: false });
    return Object.assign({}, state, {
      [exploreTabKey]: requestedUserTimeline,
    });

  case RECEIVE_EXPLORE_TIMELINE:
    // TODO: We'll need to get smarter about this
    // For example, sorting by date when new items are added
    newTimeline = state[exploreTabKey] && state[exploreTabKey].feedItems ?
      state[exploreTabKey].feedItems.slice() : [];
    const isEndOfTimeline = action.payload.response.feedItems && action.payload.response.feedItems.length === 0;
    const feedItemsArray = action.payload.response.feedItems || [];
    const feedContentIds = feedItemsArray.map(f => {
      return {feedContentId: f.content.feedContentId, isSponsored: f.isSponsored};
    });

    newTimeline = newTimeline.concat(feedContentIds);
    return Object.assign({}, state, {
      [exploreTabKey]: {
        isEndOfTimeline,
        isError: false,
        isFetching: false,
        feedItems: newTimeline,
      },
    });
  case FAIL_DISMISS_EXPLORE_FEED_ITEM:
    newTimeline = populateExploreTimeline(state, action, {
      dismissFeedItem: {
        feedContentId: action.payload.feedContentId,
        isRequesting: false,
        isError: true,
      }});
    return Object.assign({}, state, {
      [exploreTabKey]: newTimeline,
    });
  case REQUEST_DISMISS_EXPLORE_FEED_ITEM:
    const currentDismissItem = state[exploreTabKey].dismissFeedItem || {};
    currentDismissItem.feedContentId = action.payload.feedContentId;
    currentDismissItem.isRequesting = true;
    newTimeline = populateExploreTimeline(state, action, {
      dismissFeedItem: currentDismissItem,
    });
    return Object.assign({}, state, {
      [exploreTabKey]: newTimeline,
    });
  case SUCCESS_DISMISS_EXPLORE_FEED_ITEM:
    const feedContentId = action.payload.feedContentId;
    const feedItems = state[exploreTabKey] && state[exploreTabKey].feedItems ?
      state[exploreTabKey].feedItems.slice() : [];
    const itemIndex = feedItems.findIndex(fi => fi.feedContentId === feedContentId);
    if (itemIndex > -1) {
      feedItems.splice(itemIndex, 1);
    }
    newTimeline = populateExploreTimeline(state, action, {
      feedItems,
      dismissFeedItem: {
        feedContentId,
        isRequesting: false,
        isError: false,
      }});
    return Object.assign({}, state, {
      [exploreTabKey]: newTimeline,
    });

  // these would be for the profile timelines
  // case HIDE_CONFIRM_DISMISS_FEED_ITEM:
  //   newTimeline = populateUserTimeline(state, action, { dismissFeedItem: null });
  //   return Object.assign({}, state, {
  //     [feedUserKey]: newTimeline,
  //   });
  // case SHOW_CONFIRM_DISMISS_FEED_ITEM:
  //   newTimeline = populateUserTimeline(state, action, {
  //     dismissFeedItem: {
  //       feedContentId: action.payload.feedContentId,
  //       isRequesting: false,
  //       isError: false,
  //     }});
  //   return Object.assign({}, state, {
  //     [feedUserKey]: newTimeline,
  //   });

  default:
    return state;
  }
}
